<script setup>
import defaultLayout from '@/layouts/default.vue';
import authLayout from '@/layouts/auth.vue';
import kbLayout from '@/layouts/kb.vue';
import errorLayout from '@/layouts/error.vue';
import { watchEffect } from 'vue';

const layouts = {
    kb: kbLayout,
    auth: authLayout,
    default: defaultLayout,
    error: errorLayout
}
const route = useRoute();
const layout = computed(() => {
    return route.matched.at(-1).components.default?.layout ?? 'default';
})
const system = useSystemStore();
watchEffect(() => {
    if (system.systemSettings.system_title) {
        document.title = system.systemSettings.system_title;
        useHeadTag().add('link[rel*="icon"]', 'link', { type: 'image/x-icon', rel: 'shortcut icon', href: system.systemSettings.favicon_name ?? '/favicon.ico' });
    }
});
</script>

<template>
    <v-app style="background-color: #f3f6fa">
        <connection />
        <toast />
        <loading />
        <router-view v-slot="{ Component }">
            <component v-if="route.matched.length" :is="layouts[layout]">
                <component :is="Component" />
            </component>
        </router-view>
    </v-app>
</template>
